import React from "react";
import { createState } from "src/utils/create_zustand_store";

async function attachMiddlewareLibScript() {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.async = true;
    script.src =
      "https://cdnjs.middleware.io/browser/libs/1.0.3-nzcm/middleware-rum.min.js";
    script.id = "middleware-lib";
    document.head.appendChild(script);
    script.onload = () => {
      if (!window.Middleware) reject("Error loading middleware lib");
      else resolve(true);
    };
  });
}

function initMiddleware() {
  return new Promise((resolve, reject) => {
    if (window.Middleware) {
      window.Middleware.track({
        serviceName: "pass-v3-frontend",
        projectName: "pass-v3-frontend",
        accountKey: "tugoumkvmvvqkruymultryijqjskzftnycbk",
        target: "https://wcchz.middleware.io",
        defaultAttributes: {
          "app.version": "1.0.0",
        },
        recordingOptions: {
          maskTextSelector: "*",
          maskAllInputs: true,
        },
      });
      resolve(true);
    } else {
      reject("Error initializing middleware");
    }
  });
}

async function checkDocumentHeadReadyState(): Promise<boolean> {
  return new Promise((resolve, reject) => {
    let lastMutationTime = Date.now();

    const observer = new MutationObserver(() => {
      lastMutationTime = Date.now();
    });

    observer.observe(document.head, { childList: true, subtree: true });

    let interval = setInterval(() => {
      const currentTime = Date.now();
      const timeDiff = currentTime - lastMutationTime;

      const isReady = timeDiff > 3000 && timeDiff < 5000;
      const isTimeout = timeDiff > 5000;

      if (isReady) resolve(true);
      if (isTimeout) reject("Document head not ready");
      if (isReady || isTimeout) {
        clearInterval(interval);
        observer.disconnect();
      }
    }, 1000);
  });
}

async function loadMiddleware(callback?: () => void) {
  try {
    const isReady = await checkDocumentHeadReadyState();
    if (isReady) {
      await attachMiddlewareLibScript();
      await initMiddleware();
    }
    callback?.();
  } catch (error) {
    console.log("error loading middleware");
    console.log(error);
  }
}

const useMiddlewareState = createState({
  isLoaded: false,
});

export default function MiddlewareIoScriptsContainer() {
  const middlewareState = useMiddlewareState();

  React.useEffect(() => {
    if (process.env.NODE_ENV == "development") return;
    if (middlewareState.isLoaded) return;

    loadMiddleware(() => {
      middlewareState.set({ isLoaded: true });
    });
  }, []);

  return <></>;
}
